var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEventListener, FocusEventListener, KeyboardEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isEnumValid, isValidWidth } from '@philips-internal/oswald-ui-utils';
import { FieldVisibility } from './field-constants.js';
class BaseFieldAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
        /** @event */
        this.onBlur = new FocusEventListener();
        /** @event */
        this.onFocus = new FocusEventListener();
        /** @event */
        this.onKeyDown = new KeyboardEventListener();
        /** @event */
        this.onKeyPress = new KeyboardEventListener();
        /** @event */
        this.onKeyUp = new KeyboardEventListener();
    }
    isVisible() {
        return Boolean(this.state.visible);
    }
    setVisible(visible) {
        this.setState({ ...this.state, visible });
    }
    getData() {
        return this.state.data ?? {};
    }
    setData(data) {
        this.setState({ ...this.state, data });
    }
    getEntry() {
        return this.state.entry;
    }
    setEntry(entry) {
        this.setState({ ...this.state, entry });
    }
    getLabel() {
        return this.state.label;
    }
    setLabel(label) {
        this.setState({ ...this.state, label });
    }
    setWidth(width) {
        if (isValidWidth(width)) {
            this.setState({ ...this.state, width });
        }
    }
    getWidth() {
        return this.state.width;
    }
    setVisibility(visibility) {
        if (!isEnumValid(FieldVisibility, visibility))
            return;
        this.setState({ ...this.state, visibility });
    }
    getVisibility() {
        return this.state.visibility ?? FieldVisibility.BOTH;
    }
    isAlwaysShowLabel() {
        return Boolean(this.state.alwaysShowLabel);
    }
    setAlwaysShowLabel(alwaysShowLabel) {
        this.setState({ ...this.state, alwaysShowLabel });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFieldAPI.prototype, "onChange", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFieldAPI.prototype, "onBlur", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFieldAPI.prototype, "onFocus", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFieldAPI.prototype, "onKeyDown", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFieldAPI.prototype, "onKeyPress", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseFieldAPI.prototype, "onKeyUp", void 0);
export { BaseFieldAPI, };
export default BaseFieldAPI;
//# sourceMappingURL=base-field-api.js.map